import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/login/page";
import AdminMembers from "@/pages/admin/page";
import AdminMemberNew from "@/pages/admin/new/page";
import AdminImport from "@/pages/admin/import/page";
import AdminStaff from "@/pages/admin/staff/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/admin" replace />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminMembers />,
  },
  {
    path: "/admin/new",
    element: <AdminMemberNew />,
  },
  {
    path: "/admin/import",
    element: <AdminImport />,
  },
  {
    path: "/admin/staff",
    element: <AdminStaff />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;